import { T } from 'gt-react';
import { formatOverrideCurrency } from './overrideSectionFormat';
import type { OverrideSectionVendor } from './overrideSectionTypes';

export function OverrideSectionVendorField({
  vendors,
  effectiveVendorId,
  onVendorIdChange,
  inputClass,
}: {
  vendors: readonly OverrideSectionVendor[];
  effectiveVendorId: string;
  onVendorIdChange: (vendorId: string) => void;
  inputClass: string;
}) {
  return (
    <label className="col-span-2 flex flex-col gap-1">
      <span className="text-gray-500">
        <T context="override field buy from">Buy from (vendor)</T>
      </span>
      {vendors.length === 0 ? (
        <span className="text-xs text-amber-700">
          <T context="override no vendors">No vendor supplies this SKU.</T>
        </span>
      ) : (
        <select
          value={effectiveVendorId}
          onChange={(e) => onVendorIdChange(e.target.value)}
          className={inputClass}
        >
          {vendors.map((v) => (
            <option key={v.supplierId} value={v.supplierId}>
              {v.supplierName} — {formatOverrideCurrency(v.unitPrice)}
              {v.movThreshold != null
                ? ` · MOV ${formatOverrideCurrency(v.movThreshold)}`
                : ''}
            </option>
          ))}
        </select>
      )}
    </label>
  );
}
